import { defineStyleConfig } from "@chakra-ui/react";
export const Card = defineStyleConfig({
    baseStyle: {
        borderRadius: "8px",
        padding: "8px",
    },
});
//# sourceMappingURL=Card.js.map